import React, { PureComponent } from 'react';
import Modal from '../modal';

class Common extends PureComponent {

  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };

    this.rectClassName = this.props.noInterestPlan ? 'pni-cell' : 'non-pni-cell';
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const {
      modalContent,
      boxText,
      description,
      title,
      subTitle,
      id
    } = this.props;

    return (
      <div className='payment-plans-mobile'>
        <div className='payment-plan-title'>{title}</div>
          <table data-test-id={id} className='payment-plan-box'>
            <tbody>
              <tr>
                <td className={this.rectClassName}></td>
                <td className='text-cell'>{boxText}</td>
              </tr>
            </tbody>
          </table>
        <div className='payment-plan-info'>
          <b>{subTitle}</b>
          <br />
          {description} <a className='view-details' onClick={this.handleShow}>View Details</a>
        </div>

        <Modal
          isOpen={this.state.show}
          onClose={this.handleClose}
          title={title}
          className='modal-payment-plan'
          centered
        >
          <div dangerouslySetInnerHTML={{ __html: modalContent }} />
        </Modal>
    </div>);
  }
}

export default Common;

